import React from "react";
import { Router, Route } from "react-router";

import "./components/global.js";

import Loading from "./page/Loading";
import Login from "./page/Login";
import ChooseProject from "./page/ChooseProject";
import Customer from "./page/Customer";
import Import from "./page/Import";
import ImportCustomer from "./page/ImportCustomer";
import ImportBillWater from "./page/ImportBillWater";
import ImportBillUnitUsed from "./page/ImportBillUnitUsed";
import ImportPaymentHistory from "./page/ImportPaymentHistory";
import Export from "./page/Export";
import RecordWaterUsage from "./page/consumption_data/RecordWaterUsage";
import WaterUsageInfo from "./page/consumption_data/WaterUsageInfo";

import TempRecordWaterUsage from "./page/consumption_data/TempRecordWaterUsage";

import Billing from "./page/storage_data/Billing";
import RecordReceipt from "./page/storage_data/RecordReceipt";
import ReceiptAdjustment from "./page/storage_data/ReceiptAdjustment";
import RecordOther from "./page/storage_data/RecordOther";
import RecordBill from "./page/storage_data/RecordBill";
import RecordBillHistory from "./page/storage_data/RecordBillHistory";
import BillWater from "./page/storage_data/BillWater";
import Remittance from "./page/storage_data/Remittance";
import UsageHistory from "./page/storage_data/UsageHistory";
import CapitalPaymentInfo from "./page/storage_data/CapitalPaymentInfo";
import WaterPaymentInfo from "./page/storage_data/WaterPaymentInfo";
import WriteOfDept from "./page/storage_data/WriteOfDept";
import ListCutOf from "./page/storage_data/ListCutOf";

import BookBank from "./page/BookBank";
import Statement from "./page/Statement";
import Report from "./page/Report";

import Employee from "./page/employee/Employee";
import Role from "./page/employee/Role";
import CreateRole from "./page/employee/CreateRole";
import UpdateRole from "./page/employee/UpdateRole";

import ManageWater from "./page/setting/ManageWater";
import ProfileCode from "./page/setting/ProfileCode";
import Logfile from "./page/setting/Logfile";
import Profile from "./page/setting/Profile";

import Letter from "./page/setting/document/Letter";
import InvoiceByRoom from "./page/setting/document/InvoiceByRoom";
import Receipt from "./page/setting/document/Receipt";
import ReceiptOther from "./page/setting/document/ReceiptOther";
import InvoiceOther from "./page/setting/document/InvoiceOther";

import DocReceipt from "./document/Receipt";
import DocReceiptOther from "./document/ReceiptOther";
import DocInvoiceOther from "./document/InvoiceOther";
import DocInvoiceByRoom from "./document/InvoiceByRoom";
import DocLetter from "./document/Letter";
const Routes = (props) => (
  <Router {...props}>
    <Route path="/" component={Loading} />
    <Route path="/login" component={Login} />
    <Route path="/choose-project" component={ChooseProject} />
    <Route path="/customer" component={Customer} />
    <Route path="/import" component={Import} />
    <Route path="/import-customer" component={ImportCustomer} />
    <Route path="/import-bill-water" component={ImportBillWater} />
    <Route path="/import-bill-unit-used" component={ImportBillUnitUsed} />
    <Route path="/import-payment-history" component={ImportPaymentHistory} />
    <Route path="/export" component={Export} />
    <Route path="/record-water-usage" component={RecordWaterUsage} />
    <Route path="/water-usage-info" component={WaterUsageInfo} />

    <Route path="/temp-record-water-usage" component={TempRecordWaterUsage} />

    <Route path="/billing" component={Billing} />
    <Route path="/record-receipt" component={RecordReceipt} />
    <Route path="/receipt-adjustment" component={ReceiptAdjustment} />
    <Route path="/record-other" component={RecordOther} />
    <Route path="/record-bill" component={RecordBill} />
    <Route path="/record-bill-history" component={RecordBillHistory} />
    <Route path="/bill-water" component={BillWater} />
    <Route path="/remittance" component={Remittance} />
    <Route path="/usage-history" component={UsageHistory} />
    <Route path="/capital-payment-info" component={CapitalPaymentInfo} />
    <Route path="/water-payment-info" component={WaterPaymentInfo} />
    <Route path="/write-of-dept" component={WriteOfDept} />
    <Route path="/cut-of" component={ListCutOf} />

    <Route path="/all-report" component={Report} />

    <Route path="/employee" component={Employee} />
    <Route path="/role" component={Role} />
    <Route path="/create-role" component={CreateRole} />
    <Route path="/update-role" component={UpdateRole} />

    <Route path="/manage-water" component={ManageWater} />
    <Route path="/profile-code" component={ProfileCode} />
    <Route path="/logfile" component={Logfile} />
    <Route path="/profile" component={Profile} />
    <Route path="/bookbank" component={BookBank} />
    <Route path="/statement" component={Statement} />

    <Route path="/letter" component={Letter} />
    <Route path="/invoice-by-room" component={InvoiceByRoom} />
    <Route path="/receipt" component={Receipt} />
    <Route path="/receipt-other" component={ReceiptOther} />
    <Route path="/invoice-other" component={InvoiceOther} />

    <Route path="/doc/receipt" component={DocReceipt} />
    <Route path="/doc/receipt-other" component={DocReceiptOther} />
    <Route path="/doc/invoice-other" component={DocInvoiceOther} />
    <Route path="/doc/invoice-by-room" component={DocInvoiceByRoom} />
    <Route path="/doc/letter" component={DocLetter} />
  </Router>
);

export default Routes;
